// `Promise.allSettled` is ES2020. @sentry/core calls it from client flush and
// its timer util, so engines without it (iOS 12 Safari / in-app browsers,
// Chrome Mobile 72) throw `Promise.allSettled is not a function`. Self-detects
// native support and does nothing when present.

export function installPromiseAllSettledPolyfill(): void {
  if (
    typeof Promise === "undefined" ||
    typeof Promise.allSettled === "function"
  )
    return
  Promise.allSettled = function allSettled(values: Iterable<unknown>) {
    return Promise.all(
      Array.from(values, (v) =>
        Promise.resolve(v).then(
          (value) => ({ status: "fulfilled", value }),
          (reason) => ({ status: "rejected", reason })
        )
      )
    ) as never
  }
}

installPromiseAllSettledPolyfill()
